import { render, staticRenderFns } from "./ErrorAnimation.vue?vue&type=template&id=f8ec296e&scoped=true"
var script = {}
import style0 from "./ErrorAnimation.vue?vue&type=style&index=0&id=f8ec296e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8ec296e",
  null
  
)

export default component.exports